// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Where the value of one outbound command argument comes from.
 */
export enum ArgSource {
  Constant = 0,
  Controller = 1,
  Position = 2,
  Active = 3,
  Value = 4,
}
